module.exports = __webpack_public_path__ + "static/arminvanbuuren_3-d9197f32af84812be86477b34cc3453c.jpg";